import { ResponseWrapper } from '@/api/types/base.types'
import { AxiosResponse } from 'axios'

export const isError = (
  response: AxiosResponse<ResponseWrapper<any>, any>,
): boolean => {
  return (
    !response.status ||
    response.status < 200 ||
    response.status >= 300 ||
    response?.data?.status !== 'success'
  )
}
